import { render, staticRenderFns } from "./CommCdDescTable.vue?vue&type=template&id=0ca3950e&"
import script from "./CommCdDescTable.vue?vue&type=script&lang=js&"
export * from "./CommCdDescTable.vue?vue&type=script&lang=js&"
import style0 from "./CommCdDescTable.vue?vue&type=style&index=0&id=0ca3950e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports